import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";

const Dropdown = ({
  bottomHeight,
  isOpen,
  handleDismiss,
  isHeightBasedOnContent = false,
  children,
  footer,
  testId,
  ...props
}) => {
  if (isHeightBasedOnContent) {
    return (
      <BottomSheet
        open={isOpen}
        onDismiss={handleDismiss}
        initialFocusRef={false}
        footer={footer}
        data-cy={testId}
        {...props}
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <BottomSheet
      open={isOpen}
      onDismiss={handleDismiss}
      defaultSnap={bottomHeight}
      snapPoints={({ maxHeight }) => [
        maxHeight - maxHeight / 10, //highest
        maxHeight / 4, // smallest
        maxHeight * 0.4, // smallest
        maxHeight * 0.6 // medium
      ]}
      initialFocusRef={false}
      footer={footer}
      data-cy={testId}
      {...props}
    >
      {children}
    </BottomSheet>
  );
};
export default Dropdown;
